//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {},
  methods: {
    slice(index) {
      this.api.dynamicModals.splice(index, 1)
    },
    beforeOpen(e, modal, index) {
      e.ref.params = modal.params
      this.$nextTick(() => {
        if (!modal.value) {
          this.slice(index)
          modal.reject('show')
        }
      })
    },
    isString(val) {
      return typeof val === 'string'
    }
  }
}
